import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import { takeEvery, call, put, select } from "redux-saga/effects";
import { 
  CREATE_MICRO_LEARNING_REQUEST, CREATING_MICRO_LEARNING_FAILED, CREATING_MICRO_LEARNING_SUCCEEDED, 
  FETCH_MICROLEARNING_REQUEST, FETCHING_MICROLEARNINGS_SUCCEEDED, FETCHING_MICROLEARNINGS_FAILED, 
  FETCH_MICROLEARNINGS_REQUEST, FETCHING_MICROLEARNING_SUCCEEDED, FETCHING_MICROLEARNING_FAILED,
  GENERATE_ARTICLE_REQUEST,
  GENERATING_ARTICLE_SUCCEEDED,
  GENERATING_ARTICLE_FAILED,
  INVALIDATE_MICROLEARNING_CREATION,
  INVALIDATE_MICROLEARNING_DELETION,
  GENERATE_PODCAST_FOR_MICRO_LEARNING_REQUEST,
  GENERATING_PODCAST_FOR_MICRO_LEARNING_SUCCEEDED,
  GENERATING_PODCAST_FOR_MICRO_LEARNING_FAILED,
  SYNC_MICROLEARNING_PODCAST_STATE_REQUEST,
  SYNCING_MICROLEARNING_PODCAST_STATE_SUCCEEDED,
  SYNCING_MICROLEARNING_PODCAST_STATE_FAILED,
  INVALIDATE_MICROLEARNING_PODCAST_STATE,
} from "../actionTypes";
import { CreateMicroLearningErrorResponse, CreateMicroLearningRequest, CreateMicroLearningResponse, FetchLearningRequest, FetchMicroLearningsRequest, FetchMicroLearningsErrorResponse, FetchMicroLearningsResponse, FetchMicroLearningResponse, FetchMicroLearningErrorResponse, GenerateArticleRequest, GenerateArticleResponse, GenerateArticleErrorResponse, GeneratePodcastForMicroLearningRequest } from "src/types/coaching/microLearning";
import buildUrl from "build-url-ts";
import _ from "lodash";
import { DELETE_MICROLEARNING_REQUEST, DELETING_MICROLEARNING_SUCCEEDED, DELETING_MICROLEARNING_FAILED } from "../actionTypes";
import { DeleteMicroLearningRequest, DeleteMicroLearningResponse, DeleteMicroLearningErrorResponse } from "src/types/coaching/microLearning";


// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_COACHING_SEARCH_API_URL}`;

// fetch courses
export const createMicroLearning = createAction<CreateMicroLearningRequest>(CREATE_MICRO_LEARNING_REQUEST);
const createMicroLearningSucceeded = createAction<CreateMicroLearningResponse>(CREATING_MICRO_LEARNING_SUCCEEDED);
const createMicroLearningFailed = createAction<CreateMicroLearningErrorResponse>(CREATING_MICRO_LEARNING_FAILED);

const createMicroLearningSaga = function* (action: ReturnType<typeof createMicroLearning>): any {
  const request = action.payload as CreateMicroLearningRequest;
  const {query, assets} = request;

  const url = buildUrl(apiUrl, {
    path: `coaching/3.0/micro-learning`,
  });

  const createMicroLearningApi = () => {
    return axios({
      method: "POST",
      url: url,
      data: request,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createMicroLearningApi);
    yield put(
      createMicroLearningSucceeded({
        id: response.id,
        response: response,
      }),
    );
  } catch (error) {
    yield put(createMicroLearningFailed({query: query, error: error }));
  }
};

export const fetchMicroLearnings = createAction<FetchMicroLearningsRequest>(FETCH_MICROLEARNINGS_REQUEST);
const fetchMicroLearningsSucceeded = createAction<FetchMicroLearningsResponse>(FETCHING_MICROLEARNINGS_SUCCEEDED);
const fetchMicroLearningsFailed = createAction<FetchMicroLearningsErrorResponse>(FETCHING_MICROLEARNINGS_FAILED);

const fetchMicroLearningsSaga = function* (action: ReturnType<typeof fetchMicroLearnings>):any {
  const request = action.payload as FetchMicroLearningsRequest;
  const url = buildUrl(apiUrl, {
    path: `coaching/3.0/micro-learning`,
  });

  const fetchMicroLearningsAPI = () => {
    return axios({
      method: "GET",
      url: url,
      params: request
    }).then((response) => response.data);
  }

  try {
    const response = yield call(fetchMicroLearningsAPI);
    yield put(
      fetchMicroLearningsSucceeded({
        response: response
      })
    )
  } catch (error) {
    yield put(fetchMicroLearningsFailed({error:error}))
  }

}

export const fetchMicroLearning = createAction<string>(FETCH_MICROLEARNING_REQUEST);
const fetchMicroLearningSucceeded = createAction<FetchMicroLearningResponse>(FETCHING_MICROLEARNING_SUCCEEDED);
const fetchMicroLearningFailed = createAction<FetchMicroLearningErrorResponse>(FETCHING_MICROLEARNING_FAILED);

const fetchMicroLearningSaga = function* (
  action: ReturnType<typeof fetchMicroLearning>,
): any {
  const id = action.payload as string;

  const url = buildUrl(apiUrl, {
    path: `coaching/3.0/micro-learning/${id}`,
  });

  const fetchLearningApi = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLearningApi);

    yield put(
      fetchMicroLearningSucceeded({
        id,
        response,
      }),
    );
  } catch (error) {
    yield put(
      fetchMicroLearningFailed({
        id,
        error,
      }),
    );
  }
};

export const generateArticle = createAction<GenerateArticleRequest>(GENERATE_ARTICLE_REQUEST);
const generateArticleSucceeded = createAction<GenerateArticleResponse>(GENERATING_ARTICLE_SUCCEEDED);
const generateArticleFailed = createAction<GenerateArticleErrorResponse>(GENERATING_ARTICLE_FAILED);

const generateArticleSaga = function* (action: ReturnType<typeof generateArticle>): any {
  const {id, assets} = action.payload;

  const url = buildUrl(apiUrl, {
    path: `coaching/3.0/micro-learning/${id}/generate-article`,
  });

  const request = _.size(assets) > 0 ? { assets } : {};

  const generateArticleApi = () => {
    return axios({
      method: "POST",
      url: url,
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(generateArticleApi);
    yield put(
      generateArticleSucceeded({
        id,
        response,
      }),
    );
  } catch (error) {
    yield put(
      generateArticleFailed({
        id,
        error,
      }),
    );
  }
};

//delete
export const deleteMicroLearning = createAction<string>(DELETE_MICROLEARNING_REQUEST);
const deleteMicroLearningSucceeded = createAction<DeleteMicroLearningResponse>(DELETING_MICROLEARNING_SUCCEEDED);
const deleteMicroLearningFailed = createAction<DeleteMicroLearningErrorResponse>(DELETING_MICROLEARNING_FAILED);

const deleteMicroLearningSaga = function* (action: ReturnType<typeof deleteMicroLearning>): any {
  const id = action.payload as string;

  const url = buildUrl(apiUrl, {
    path: `coaching/3.0/micro-learning/${id}`,
  });

  const deleteMicroLearningApi = () => {
    return axios({
      method: "DELETE",
      url: url,
    }).then((response) => response.data);
  };

  try {
    yield call(deleteMicroLearningApi);
    yield put(
      deleteMicroLearningSucceeded({
        id,
      }),
    );
  } catch (error) {
    yield put(
      deleteMicroLearningFailed({
        id,
        error,
      }),
    );
  }
};

export const invalidateMicroLearningCreation = createAction(INVALIDATE_MICROLEARNING_CREATION);
export const invalidateMicroLearningDeletion = createAction(INVALIDATE_MICROLEARNING_DELETION);

export const generatePodcastForMicroLearning = createAction<GeneratePodcastForMicroLearningRequest>(GENERATE_PODCAST_FOR_MICRO_LEARNING_REQUEST);

const generatingPodcastForMicroLearningSucceeded = createAction<any>(GENERATING_PODCAST_FOR_MICRO_LEARNING_SUCCEEDED);
const generatingPodcastForMicroLearningFailed = createAction<any>(GENERATING_PODCAST_FOR_MICRO_LEARNING_FAILED);

export const generatePodcastForMicroLearningSaga = function* (action: ReturnType<typeof generatePodcastForMicroLearning>): any {
  const { id, duration, type } = action.payload as GeneratePodcastForMicroLearningRequest;

  const url = buildUrl(apiUrl, {
    path: `coaching/3.0/micro-learning/${id}/generate-podcast`,
  });

  const request = {
    duration,
    type,
  };

  const generatePodcastForMicroLearningAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: request,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(generatePodcastForMicroLearningAPI);
    yield put(generatingPodcastForMicroLearningSucceeded({ id: id, response: response }));
  } catch (error) {
    yield put(generatingPodcastForMicroLearningFailed({ id: id, error: error }));
  }
}

export const invalidateMicroLearningPodcastState = createAction<string>(INVALIDATE_MICROLEARNING_PODCAST_STATE);

export default function* microLearningSaga() {
  yield takeEvery(CREATE_MICRO_LEARNING_REQUEST, createMicroLearningSaga);
  yield takeEvery(FETCH_MICROLEARNINGS_REQUEST, fetchMicroLearningsSaga);
  yield takeEvery(FETCH_MICROLEARNING_REQUEST, fetchMicroLearningSaga);
  yield takeEvery(GENERATE_ARTICLE_REQUEST, generateArticleSaga);
  yield takeEvery(DELETE_MICROLEARNING_REQUEST, deleteMicroLearningSaga);
  yield takeEvery(GENERATE_PODCAST_FOR_MICRO_LEARNING_REQUEST, generatePodcastForMicroLearningSaga);
}
